import { render, staticRenderFns } from "./table-datalog.vue?vue&type=template&id=c891fd52&"
import script from "./table-datalog.vue?vue&type=script&lang=ts&"
export * from "./table-datalog.vue?vue&type=script&lang=ts&"
import style0 from "./table-datalog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports